import { Dispatch } from 'redux';
import { toasterMsg } from 'Components/Toaster/Toaster';
import {
  listControlLibraries,
  listLibraryCards,
  createLibraryCard,
  deleteLibraryCard,
} from 'services/control-library.services';
import ControlLibraryType from './ControlLibrary.type';
import type { ActionGetState } from './ControlLibrary.action.types';

const ERROR_MSG = 'Something went wrong. Please try again.';

export const fetchLibraries = (params: { search?: string; pageIndex?: number; pageSize?: number; append?: boolean } = {}) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: ControlLibraryType.SET_LOADING, payload: true });
    try {
      const searchParam = params.search !== undefined ? { search: params.search } : {};
      const res = await listControlLibraries({ ...searchParam, pageIndex: params.pageIndex || 1, pageSize: params.pageSize || 50 });
      const data = res?.data;
      if (params.append) {
        dispatch({ type: ControlLibraryType.APPEND_LIBRARIES, payload: data?.records || [] });
      } else {
        dispatch({ type: ControlLibraryType.SET_LIBRARIES, payload: data?.records || [] });
      }
      dispatch({ type: ControlLibraryType.SET_LIBRARIES_TOTAL, payload: data?.total || 0 });
      dispatch({ type: ControlLibraryType.SET_LOADING, payload: false });
      return data;
    } catch {
      toasterMsg(ERROR_MSG, 'danger');
      dispatch({ type: ControlLibraryType.SET_LOADING, payload: false });
      return null;
    }
  };

export const selectLibraryAndFetchCards = (library: { _id: string; libraryName: string; iconUrl: string; isActive: boolean; createdAt: string }) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: ControlLibraryType.SET_SELECTED_LIBRARY, payload: library });
    dispatch({ type: ControlLibraryType.SET_CARDS_LOADING, payload: true });
    try {
      const res = await listLibraryCards(library._id, { pageSize: 200 });
      const data = res?.data;
      dispatch({ type: ControlLibraryType.SET_CARDS, payload: data?.records || [] });
      dispatch({ type: ControlLibraryType.SET_CARDS_TOTAL, payload: data?.total || 0 });
      dispatch({ type: ControlLibraryType.SET_CARDS_LOADING, payload: false });
    } catch {
      toasterMsg(ERROR_MSG, 'danger');
      dispatch({ type: ControlLibraryType.SET_CARDS_LOADING, payload: false });
    }
  };

export const addLibraryCard = (libraryId: string, data: { cardName: string; tableControlIds: string[] }, t: (key: string) => string) =>
  async (dispatch: Dispatch, getState: () => ActionGetState) => {
    try {
      const res = await createLibraryCard(libraryId, data) as { data?: { data?: unknown } };
      if (res?.data?.data) {
        toasterMsg(t('CARD_CREATED'), 'success');
        const state = getState();
        const selectedLibrary = state.ControlLibraryReducer?.selectedLibrary;
        if (selectedLibrary?._id === libraryId) {
          const cardsRes = await listLibraryCards(libraryId, { pageSize: 200 });
          dispatch({ type: ControlLibraryType.SET_CARDS, payload: cardsRes?.data?.records || [] });
        }
      }
    } catch {
      toasterMsg(ERROR_MSG, 'danger');
    }
  };

export const removeLibraryCard = (libraryId: string, cardId: string, t: (key: string) => string) =>
  async (dispatch: Dispatch, getState: () => ActionGetState) => {
    try {
      await deleteLibraryCard(libraryId, cardId);
      toasterMsg(t('CARD_DELETED'), 'success');
      const state = getState();
      const selectedLibrary = state.ControlLibraryReducer?.selectedLibrary;
      if (selectedLibrary?._id === libraryId) {
        const cardsRes = await listLibraryCards(libraryId, { pageSize: 200 });
        dispatch({ type: ControlLibraryType.SET_CARDS, payload: cardsRes?.data?.records || [] });
      }
    } catch {
      toasterMsg(ERROR_MSG, 'danger');
    }
  };
